import type { JSX } from "react";
import { IconButton, Plus } from "@/common-ui";
import { useControlsStore } from "../controls.store";

interface TransferButtonProps {
    disabled?: boolean;
}

export function ToggleTransferPanelButton({ disabled = false, ...props }: TransferButtonProps): JSX.Element {
    const { toggleTransferActive, transferCallActive } = useControlsStore();
    const tooltipLabel = !disabled ? "Add and transfer" : "Max participants reached";

    return (
        <IconButton
            active={transferCallActive}
            analytics={{
                actionId: "TransferCallButton",
            }}
            data-testid="call-controls-transfer"
            disabled={disabled}
            onClick={toggleTransferActive}
            radius="xl"
            size="30"
            aria-label="Add and transfer participants"
            tooltip={tooltipLabel}
            {...props}
        >
            <Plus
                height={14}
                stroke={transferCallActive ? "var(--mantine-color-dark-7)" : "var(--mantine-color-gray-0)"}
            />
        </IconButton>
    );
}
